// Vaanmathi
import {
  FaMoneyBillWave,
  FaChartLine,
  FaCog,
  FaUser,
  FaSignOutAlt,
  FaFileInvoiceDollar,
  FaUserPlus,
  FaUserTie,
  FaMapMarkerAlt,
  FaClock,
  FaLocationArrow,
  FaListUl,
  FaEdit,
  FaCheckCircle,
  FaTimesCircle,
  FaHandHoldingUsd,
  FaFolderOpen,
  FaUserShield,
  FaKey,
  FaBlogger,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { BsFillCalendarDateFill } from "react-icons/bs";

export const sidebarMenuItems = [
  {
    id: "dashboard",
    title: "Payroll Dashboard",
    icon: MdDashboard,
    path: "/dashboard",
    isActive: true,
  },

  {
    id: "addlocation",
    title: "Add Location",
    icon: FaLocationArrow,
    path: "/addlocation",
  },

  {
    id: "empdetail",
    title: "Manage Employee",
    icon: FaUserTie,
    hasSubmenu: true,
    children: [
      {
        id: "usermng",
        title: "Add Employee",
        icon: FaUserPlus,
        path: "/usermng",
      },
      {
        id: "empdetails",
        title: "Add Employees Detail",
        icon: FaUserPlus,
        path: "/empdetails",
      },
      {
        id: "empdetail",
        title: "Employees Detail Approved",
        icon: FaCheckCircle,
        path: "/empdetail",
      },
      {
        id: "empdetailsunapproved",
        title: "Employees Detail Unapproved",
        icon: FaTimesCircle,
        path: "/empdetailsunapproved",
      },
      {
        id: "employeemanagement",
        title: "Active / Inactive",
        icon: FaUserShield,
        path: "/employeemanagement",
      },
    ],
  },
  {
    id: "ManageEmployeeLocation",
    title: "Manage Employee Location",
    icon: FaMapMarkerAlt,
    hasSubmenu: true,
    children: [
      {
        id: "assignlocation",
        title: "Assign Employee Location",
        icon: FaListUl,
        path: "/assignlocation",
      },
      {
        id: "editlocation",
        title: "Edit Employee Location",
        icon: FaEdit,
        path: "/EditUsersLocation",
      },
    ],
  },

  {
    id: "setsalary",
    title: "Manage Salary",
    icon: FaMoneyBillWave,
    hasSubmenu: true,
    children: [
      {
        id: "setsalary",
        title: "Set Salary",
        icon: FaHandHoldingUsd,
        path: "/setsalary",
      },
      {
        id: "employees",
        title: "Assign PayPeriod",
        icon: FaClock,
        path: "/employees",
      },
      {
        id: "addhours",
        title: "Add Hours & Pay Salary",
        icon: FaClock,
        path: "/addhours",
      },
    ],
  },
  {
    id: "payslip",
    title: "Payslip Management",
    icon: FaFileInvoiceDollar,
    hasSubmenu: true,
    children: [
       {
        id: "payslipdata",
        title: "Payslip Configuration",
        icon: FaCog,
        path: "/payslipdata",
      },
      {
        id: "payslip-generate",
        title: "Payslip Generator",
        icon: FaFileInvoiceDollar,
        path: "/payslip-generate",
      },
      {
        id: "paysliprecord",
        title: "Payslip Record",
        icon: FaFolderOpen,
        path: "/paysliprecord",
      },
      {
        id: "payrollconfigurator",
        title: "Payroll Configurator",
        icon: FaCog,
        path: "/payrollconfigurator",
      },
    ],
  },

  {
    id: "leavemanagement",
    title: "Leave Management",
    icon: BsFillCalendarDateFill,
    path: "/leavemanagement",
  },

  {
    id: "settings",
    title: "Settings",
    icon: FaCog,
    hasSubmenu: true,
    children: [
      {
        id: "revenue",
        title: "Revenue",
        icon: FaChartLine,
        path: "/revenue",
      },
      {
        id: "adminmanagement",
        title: "Admin Management",
        icon: FaUserShield,
        path: "/adminmanagement",
      },
      {
        id: "userauthentication",
        title: "User Authentication",
        icon: FaKey,
        path: "/UserAuthentication",
      },
      {
        id: "auditlogs",
        title: "Audit Logs",
        icon: FaBlogger,
        path: "/AuditTrailLogs",
      },
    ],
  },
];

export const userMenuItems = [
  {
    id: "profile",
    title: "Profile",
    icon: FaUser,
    path: "/profile",
  },
  {
    id: "settings",
    title: "Settings",
    icon: FaCog,
    path: "/settings",
  },
  {
    id: "logout",
    title: "Logout",
    icon: FaSignOutAlt,
    action: "logout",
  },
];
